import type { EmployerAgreementCommandData } from '@festina/life-general-types/life'
import type { ExcludeString } from '@festina-life/core'

import { AmendEmployerAgreementPoliciesCommand } from '../../employerAgreement/amendPolicies/AmendEmployerAgreementPoliciesCommand'
import { ChangeContributionDataCommand } from '../../employerAgreement/ChangeContributionDataCommand'
import { ChangeTemplateSourceCommand } from '../../employerAgreement/ChangeTemplateSourceCommand'
import { CreateAgreementCommand } from '../../employerAgreement/createAgreement/CreateAgreementCommand'
import { EmployerAgreementCommandModalButtonFallback } from '../EmployerAgreementCommandModalButtonFallback'
import type { CommandDataRecord } from '../types'

export const employerAgreementCommands: CommandDataRecord<
  ExcludeString<EmployerAgreementCommandData['_type']>
> = {
  //   Seems to live in DK, some fields/frame missing
  AmendEmployerAgreementCommandData:
    EmployerAgreementCommandModalButtonFallback,
  //   Lives in DK
  AmendEmployerAgreementCoversCommandData:
    EmployerAgreementCommandModalButtonFallback,
  AmendEmployerAgreementPoliciesCommandData:
    AmendEmployerAgreementPoliciesCommand,
  ChangeAgreementCommandData: EmployerAgreementCommandModalButtonFallback,
  ChangeCommitmentTemplateSourceCommandData:
    EmployerAgreementCommandModalButtonFallback,
  ChangeContributionDataCommandData: ChangeContributionDataCommand,
  ChangeNameCommandData: EmployerAgreementCommandModalButtonFallback,
  ChangeTemplateSourceCommandData: ChangeTemplateSourceCommand,
  CreateAgreementCommandData: CreateAgreementCommand,
  EmployerAgreementRollbackCommandData:
    EmployerAgreementCommandModalButtonFallback,
} as const
